export const filterTypes ={
    'DEVICE_TYPE': 'deviceType',
    'IOT_CAPABILITY_STATUS': 'iotCapability',
}